/**
 * Backbone view which provides editor functionality for a 'date' field type.
 * ## Fields
 * The `value` field gets and sets the current value.
 * ## Events
 * The `'change'` event is raised whenever the value changes. The event has a single argument, the new value.
 * @module app/Field/DateEditor
 */
import BaseFieldView from "core/views/Field/BaseFieldView";
import $ from "jquery";
import _ from "underscore";
var FORMAT = "mm/dd/yy";

export default BaseFieldView.extend({
  template: _.template(
    '<input type="date" name="<%- name %>" class="form-control date-field visible-xs" /><div class="hidden-xs"><input type="hidden" name="<%- name%>" class="datevalue" value="<%- value%>"/><input type="text" class="date-selector form-control" value="<%- datevalue%>"/></div>'
  ),

  events: {
    "change .datevalue": "onChange",
    "change .date-selector": function (evt) {
      if (!$(evt.target).val()) {
        this.value = null;

        this.onChange();
      }
    },
  },

  getControlValue: function () {
    return (
      this.$(".date-selector").datepicker("getDate") ||
      this.$(".datevalue").val()
    );
  },

  setControlValue: function (value) {
    //value should be a date
    if (!_.isDate(value)) {
      value = new Date(value);
    }

    this.$(".date-selector").datepicker("setDate", value);
  },

  serialize: function () {
    var dateValue;

    if (this.getValue()) {
      dateValue = $.datepicker.formatDate(FORMAT, new Date(this.getValue()));
    } else {
      dateValue = "";
    }

    return {
      name: this.field.id,
      value: this.getValue(),
      datevalue: dateValue,
    };
  },

  postRender: function () {
    this.$(".date-selector").datepicker({
      altField: this.$(".datevalue"),
      altFormat: FORMAT,
      dateFormat: FORMAT,
      defaultDate: this.value ? new Date(this.value) : new Date(),
      changeMonth: true,
      changeYear: true,
      onSelect: _.bind(function () {
        this.onChange();
      }, this),
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/DateEditor.js
// module id = 840
// module chunks = 1